import { SearchRounded } from '@mui/icons-material';
import React, { useState } from 'react';
import styled from 'styled-components';
import CommonButton from '../../../../components/common/CommonButton';
import { postAssignSimulation } from '../api/simulator';

const AssignModal = ({ isOpen, onClose, users, simulator }) => {
    const [search, setSearch] = useState('');
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [loadingAssign, setLoadingAssign] = useState(false);

    function handleChangeSearch(e) {
        setSearch(e.target.value);
    }

    const {
        data: fetchedUsers,
        loading,
        error
    } = users;

    const getInitials = (name) => {
        return name.split(' ').map(word => word[0]?.toUpperCase()).join('');
    }

    const handleSelectUser = (user) => {
        setSelectedUsers((prev) => {
            if (prev.includes(user)) {
                return prev.filter((u) => u.user_id !== user.user_id);
            } else {
                return [...prev, user];
            }
        });
    }

    const toggleSelectAll = () => {
        setSelectedUsers((prev) => prev.length === fetchedUsers.length ? [] : fetchedUsers);
    }

    const handleAssignUsers = async () => {
        setLoadingAssign(true);

        const payload = {
            simulator_id: simulator._id,
            assignments: selectedUsers
        }

        try {
            await postAssignSimulation(payload);
            onClose(true)
        } catch (error) {
            console.log(error)
        } finally {
            setLoadingAssign(false);
        }

    }

    if (!isOpen) return null;
    return (
        <ModalOverlay>
            <ModalBackdrop onClick={() => onClose(false)} />

            <ModalContainer>
                <ModalHeader>
                    <ModalTitle>
                        Asignar simulador
                    </ModalTitle>
                    <CloseButton onClick={() => onClose(false)}>
                        {/* Cambiar a icono de FontAwesome */}
                        <svg width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </CloseButton>
                </ModalHeader>
                <ModalBody>
                    <p>Selecciona los estudiantes que deberán realizar al simulador <b>{simulator.name}</b></p>
                    <FiltersContainer>
                        <SearchFilter>
                            <TextField
                                type="text"
                                value={search}
                                onChange={handleChangeSearch}
                                placeholder="Buscar estudiante"
                            />
                            <SearchIcon />
                        </SearchFilter>
                        <span>
                            <label>Seleccionar todos</label>
                            <input type="checkbox" onChange={toggleSelectAll} />
                        </span>
                    </FiltersContainer>
                    {
                        fetchedUsers?.length > 0 ? (
                            <UsersContainer>
                                {
                                    search.length > 0 ? (
                                        fetchedUsers.filter((user) => user.user_name.toLowerCase().includes(search.toLowerCase())).map((user) => (
                                            <UserCard key={user.id}>
                                                <section>
                                                    <span>{getInitials(user.user_name).slice(0, 2)}</span>
                                                    <label>{user.user_name}</label>
                                                </section>
                                                <input type="checkbox" onChange={() => handleSelectUser(user)} checked={selectedUsers.includes(user)} />
                                            </UserCard>
                                        ))
                                    ) : (
                                        fetchedUsers.map((user) => (
                                            <UserCard key={user.id}>
                                                <section>
                                                    <span>{getInitials(user.user_name).slice(0, 2)}</span>
                                                    <label>{user.user_name}</label>
                                                </section>
                                                <input type="checkbox" onChange={() => handleSelectUser(user)} checked={selectedUsers.includes(user)} />
                                            </UserCard>
                                        ))
                                    )
                                }
                            </UsersContainer>
                        )
                            : loading ? (
                                <p>Cargando...</p>
                            ) : (
                                <p>No hay estudiantes</p>
                            )
                    }
                    <FooterContainer>
                        <span>
                            <label>{selectedUsers.length}</label>
                            <p>Alumnos seleccionados</p>
                        </span>
                        <section>
                            <CommonButton
                                label="Cancelar"
                                variant="black&white"
                                onClick={() => onClose(false)}
                            />
                            <CommonButton
                                label={loadingAssign ? "Asignando..." : "Asignar"}
                                variant="filled"
                                disabled={loadingAssign}
                                onClick={handleAssignUsers}
                            />
                        </section>
                    </FooterContainer>
                </ModalBody>
            </ModalContainer>
        </ModalOverlay>
    );
};

export default AssignModal;

const ModalOverlay = styled.div`
    position: fixed;
    inset: 0;
    z-index: 999999999;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const ModalBackdrop = styled.div`
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s ease;
`;

const ModalContainer = styled.div`
    position: relative;
    background-color: white;
    border-radius: 20px;
    width: 60vw;
    height: 90vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 0 !important;
    box-shadow: 0px 12px 24px -15px #0000001A, 0px 0px 10px -6px #00000040;

    input[type="checkbox"] {
        appearance: none;
        width: 20px;
        height: 20px;
        border: 2px solid #49454F; /* Borde oscuro para checkbox inactivo */
        border-radius: 2px;
        outline: none;
        background-color: white;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
    }
 
    /* Efecto cuando está seleccionado */
    input[type="checkbox"]:checked {
        border-color: #b31d15; /* Borde rojo */
        background-color: #b31d15; /* Fondo rojo */
    }
 
    /* Icon check interno cuando está seleccionado */
    input[type="checkbox"]:checked::after {
        content: "✔"; /* Check */
        font-size: 14px;
        font-weight: bold;
        color: white;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
`;

const ModalHeader = styled.div`
    position: relative;
    width: calc(100% - 2rem);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    border-bottom: 1px solid #e5e7eb;
    background-color: #b31d15;
    border-radius: 20px 20px 0 0;
`;

const ModalTitle = styled.h3`
    font-size: 1.25rem;
    font-weight: 600;
    color: #fff;
`;

const CloseButton = styled.button`
    cursor: pointer;
    position: absolute;
    top: 1rem;
    right: 1rem;
    color: #FFF !important;
    background-color: transparent !important;
    border: none;
    padding: 0;
    &:hover {
        color: #6b7280;
    }
    &:focus {
        outline: none;
    }
`;

const ModalBody = styled.div`
    width: calc(100% - 4rem);
    height: 100%;
    padding: 2rem;
    display: flex;
    align-items: start;
    justify-content: start;
    flex-direction: column;
    gap: 2rem;
`;


const SearchFilter = styled.div`
  position: relative;
`

const SearchIcon = styled(SearchRounded)`
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--secondary-four);
`

const TextField = styled.input` 
  background: #FFF;
  color: #000;
  margin-bottom: 0;
  width: 309px;
  border-radius: 100px;
  height: 32px;
  border-color: transparent;
  box-shadow: 0px;
  outline: none;
  transition: 0.15s;
  text-align: start;
  padding: 12px 16px 12px 48px;
  font-size: 16px;
  border: 1px solid #A8A8A8;

  ::placeholder {
    color:  var(--secondary-four);
    opacity: 1; /* Firefox */
  }
`

const FiltersContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 1rem;

        label {
            font-size: 16px;
            font-weight: 500;
            color: #1D1D1B;
        }

        input {
            width: 18px;
            height: 18px;
            cursor: pointer;
        }
    }
`

const UsersContainer = styled.div`
    width: 100%;
    height: 100%;
    max-height: calc(90vh - 21rem);
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: auto;
    align-items: start;
    gap: 1rem;
    overflow-y: auto;
    overflow-x: hidden;
`

const UserCard = styled.div`
    width: calc(100% - 40px);
    height: 72px;
    border: .5px solid #A8A8A8;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 24px 8px 16px;

    section {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 1rem;

        span {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #b31d15;
            font-size: 16px;
            color: #fff;
        }
    }
`

const FooterContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: .5rem !important;

        label {
            width: 24px;
            height: 24px;
            border-radius: 5px;
            background-color: #616161;
            font-size: 12px;
            font-weight: 800;
            color: #fff !important;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        p {
            font-size: 14px;
            font-weight: 400;
            color: #616161;
        }
    }

    section {
        display: flex;
        align-items: center;
        gap: 1rem;
    }
`